document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lp-benefit-cards-splide').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      autoWidth: true,
      gap: '1rem',
      arrows: true,
      pagination: false,
      drag: true,
      trimSpace: 'move',
      padding: { left: '5rem', right: '5rem' },
      breakpoints: {
        767: {
          autoWidth: false,
          perPage: 1,
          pagination: true,
          padding: { left: '1rem', right: '4rem' },
        },
      },
    });

    var initialFirstLeft = 0;
    var initialLastRight = 0;
    var visibleLeft = 0;
    var visibleRight = 0;

    function measure() {
      var slides = el.querySelectorAll('.splide__slide');
      var track = el.querySelector('.splide__track');
      if (!track || !slides.length) return;
      var trackRect = track.getBoundingClientRect();
      initialFirstLeft = slides[0].getBoundingClientRect().left;
      initialLastRight = slides[slides.length - 1].getBoundingClientRect().right;
      visibleLeft = trackRect.left + 80;
      visibleRight = trackRect.right - 80;
    }

    function getTranslateX() {
      var list = el.querySelector('.splide__list');
      var style = list && list.style.transform;
      if (!style) return 0;
      var match = style.match(/translateX\((.+?)px\)/);
      return match ? parseFloat(match[1]) : 0;
    }

    function checkArrows() {
      var tx = getTranslateX();
      var finalFirstLeft = initialFirstLeft + tx;
      var finalLastRight = initialLastRight + tx;

      var prevArrow = el.querySelector('.splide__arrow--prev');
      var nextArrow = el.querySelector('.splide__arrow--next');

      if (prevArrow && finalFirstLeft >= visibleLeft - 2) {
        prevArrow.disabled = true;
      }
      if (nextArrow && finalLastRight <= visibleRight + 2) {
        nextArrow.disabled = true;
      }
    }

    splide.on('mounted', measure);
    splide.on('resized', measure);
    splide.on('arrows:updated', checkArrows);

    splide.on('mounted resized', function () {
      var total = splide.length;
      var perPage = splide.options.perPage;
      var arrows = el.querySelector('.splide__arrows');
      if (arrows) {
        arrows.style.display = total <= perPage ? 'none' : '';
      }
    });

    splide.mount();
  });
});
